<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading10">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse10" aria-expanded="false" aria-controls="collapse10">
                Verloningen
            </button>
        </h2>
        <div id="collapse10" class="accordion-collapse collapse" aria-labelledby="heading10"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Het verlonen van een tijdvak gaat in een aantal stappen.

                <div class="space20"><!----></div>

                <b>1. Invullen en/of controleren dienstverband</b><br/>
                Vul per werknemer de gegevens van en instellingen voor het dienstverband in via de knop 'Bewerken' in de
                kolom Dienstverband. Controleer altijd of de gegevens juist en up-to-date zijn.

                <div class="space20"><!----></div>
                <b>2. Invullen, aanvullen en/of controleren periodemutaties</b><br/>
                Klik voor een werknemer op de knop 'Bewerken' in de kolom 'Verloningen'. Er opent zich dan een online
                salarisberekening. Kies de gewenste periode voor het verlonen. Door het invoeren van vergoedingen en
                inhoudingen kun je direct het effect op het brutoloon, de inhoudingen en het nettoloon zien.

                <div class="space20"><!----></div>
                <b>3. Verlonen en journaliseren</b><br/>
                Nadat alle vaste en variabele periodemutaties zijn ingevoerd kun je de loonaangifte inzien en verzenden.
                Tevens kun je de loonjournaalpost voor de administratie exporteren naar een gekoppelde SnelStart
                administratie of een pdf exporteren.

            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading111">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse11" aria-expanded="false" aria-controls="collapse11">
                Invoeren van vaste vergoedingen en inhoudingen
            </button>
        </h2>
        <div id="collapse11" class="accordion-collapse collapse" aria-labelledby="heading11"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Klik op de button " + Aanpassen" vast voor het toevoegen en/of wijzigen van de vaste vergoedingen of
                inhoudingen. Dit kunnen zowel posten zijn die vallen onder het tabeltarief, het bijzonder tarief of
                netto vergoedingen dan we l inhoudingen zijn.
                <div class="space20"><!----></div>
                Vul de begindatum in, kies het salariscomponent en vul het bedrag in. Bij een einddatum in een
                verloningsperiode wordt de vermeldde vergoeding naar rato berekend.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Invoeren van variabele vergoedingen en inhoudingen
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Voor de variabel vergoedingen klik je op de button 'Toevoegen variabel'. Je kunt dan het
                salariscomponent kiezen en het gewenste bedrag.
                <div class="space20"><!----></div>
                <b>Let op:</b> Er vindt geen pro rata berekening plaats, dus vul altijd zelf het gewenste bedrag in.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Reserveringen
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Via de 'Reserveringen' kan er automatisch een opbouw plaats vinden van bijv. vakantiegeld. Met het
                invullen van het component, een percentage, de grondslag voor de reservering en de maand waarin de
                reservering vrijvalt zie je per tijdvak de beginstand, de opbouw en de eindstand.
            </div>
        </div>
    </div>
</div>

